/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global console, Excel, Microsoft, Office */
/* global global, self, window */

Office.onReady(() => {
  // If needed, Office.js is ready to be called
});

/**
 * Shows a notification when the add-in command is executed.
 * @param event
 */
function action(event) {
  // Your code goes here
  const message = {
    type: Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage,
    message: "Performed action.",
    icon: "Icon.80x80",
    persistent: true,
  };

  // Show a notification message
  Office.context.mailbox.item.notificationMessages.replaceAsync("action", message);

  // Be sure to indicate when the add-in command function is complete
  event.completed();
}

function getGlobal() {
  return typeof self !== "undefined"
    ? self
    : typeof window !== "undefined"
      ? window
      : typeof global !== "undefined"
        ? global
        : undefined;
}
export async function run(functionText) {
  try {
    await Excel.run(async (context) => {
      /**
       * Insert your Excel code here
       */
      const range = context.workbook.getSelectedRange();
      // Read the range address
      range.load("address");
      // Update the fill color
      range.formulas = [[`${functionText}`]];
      // range.format.autofitColumns();
      await context.sync();
    });
  } catch (error) {
    await Excel.run(async (context) => {
      const range = context.workbook.getSelectedRange();
      range.load("address");
      range.values = [['Vui lòng chuyển đổi dấu ";" bằng dấu "," để thực hiện chức năng']];
      await context.sync();
    });
  }
}

function colName(n) {
  var ordA = 'a'.charCodeAt(0);
  var ordZ = 'z'.charCodeAt(0);
  var len = ordZ - ordA + 1;

  var s = "";
  while (n >= 0) {
    s = String.fromCharCode(n % len + ordA) + s;
    n = Math.floor(n / len) - 1;
  }
  return s;
}

function findPosition(columnName) {
  var ordA = 'a'.charCodeAt(0);
  var ordZ = 'z'.charCodeAt(0);
  var len = ordZ - ordA + 1;

  columnName = columnName.toLowerCase(); // Chuyển chuỗi thành chữ thường để xử lý

  var position = 0;
  for (var i = 0; i < columnName.length; i++) {
    var charCode = columnName.charCodeAt(i);
    if (charCode < ordA || charCode > ordZ) {
      return -1; // Nếu có ký tự không nằm trong khoảng 'a' đến 'z'
    }
    position = position * len + (charCode - ordA + 1);
  }

  return position - 1;
}

export async function getCurrentCellAddress() {
  let address;

  await Excel.run(async (context) => {
    // Get the active cell
    let activeCell = context.workbook.getActiveCell();

    // Load the address property of the active cell
    activeCell.load("address");

    await context.sync();

    address = activeCell.address;
  });

  return address;
}

export function setArrayToExcelCells(data) {
  Excel.run(async function (context) {
    let address = await getCurrentCellAddress();
    var array = address.split('!')
    const cellAddress = array[array.length - 1];

    // Get the active worksheet
    var sheet = context.workbook.worksheets.getActiveWorksheet();

    // Calculate the number of rows and columns
    var numRows = data?.length;
    var numCols = data?.[0]?.length;

    // Calculate the range address based on the number of rows and columns
    var rangeAddress = cellAddress + ':' + colName(findPosition(cellAddress.match(/[a-zA-Z]+/)[0].toLowerCase()) + numCols - 1).toLocaleUpperCase() + (Number(cellAddress.match(/\d+$/)[0]) + numRows - 1);
    // Set the values of the cells using the data array
    var range = sheet.getRange(rangeAddress);
    range.values = data;

    return context.sync();
  }).catch(function (error) {
    console.log(error);
  });
}
async function getValuesOfRange(rangeAddress) {
  try {
    let result = await Excel.run(async (context) => {
      // Lấy worksheet hiện tại
      let sheet = context.workbook.worksheets.getActiveWorksheet();
      // Lấy phạm vi được chỉ định
      let range = sheet.getRange(rangeAddress);
      // Load giá trị trong phạm vi
      range.load("values");
      // Đồng bộ hóa để hoàn thành các yêu cầu
      await context.sync();

      return range.values;
    });

    return result;
  } catch (error) {
    console.error("Lỗi: " + error);
    return [];
  }
}
async function getNumberFormatOfRange(rangeAddress) {
  try {
    let result = await Excel.run(async (context) => {
      // Lấy worksheet hiện tại
      let sheet = context.workbook.worksheets.getActiveWorksheet();
      // Lấy phạm vi được chỉ định
      let range = sheet.getRange(rangeAddress);
      // Load giá trị trong phạm vi
      range.load("numberFormat");
      // Đồng bộ hóa để hoàn thành các yêu cầu
      await context.sync();

      return range.numberFormat;
    });

    return result;
  } catch (error) {
    console.error("Lỗi: " + error);
    return [];
  }
}

function getLetters(str) {
  let matches = str.match(/[a-zA-Z]+/);
  return matches ? matches[0] : '';
}

function getNumbers(str) {
  let matches = str.match(/\d+/);
  return matches ? matches[0] : '';
}

function splitRange(range, step) {
  const parts = range.split(':');
  const startPrefix = getLetters(parts[0]);
  const endPrefix = getLetters(parts[1]);
  const startNum = parseInt(getNumbers(parts[0]), 10);
  const endNum = parseInt(getNumbers(parts[1]), 10);
  let currentStart = startNum;
  let ranges = [];

  while (currentStart < endNum) {
    let currentEnd = currentStart + step - 1;
    if (currentEnd > endNum) {
      currentEnd = endNum;
    }
    ranges.push(`${startPrefix}${currentStart}:${endPrefix}${currentEnd}`);
    currentStart = currentEnd + 1;
  }

  return ranges;
}

const formatValues = (values, numberFormats) => {
  let resultArray = [];
  const header = values?.[0]
  const rowCount = values?.length
  const columnCount = values?.[0]?.length

  // Duyệt qua các hàng tiếp theo và tạo các đối tượng từ key và value tương ứng
  for (let row = 1; row < rowCount; row++) {
    let obj = {};
    for (let col = 0; col < columnCount; col++) {
      let key = header[col];
      let value = values[row][col];
      let numberFormat = numberFormats[row][col];

      // Kiểm tra định dạng của ô có phải là ngày không
      obj[key] = {
        value: value,
        isDateFormat: Boolean(numberFormat && numberFormat.includes("d"))
      };

    }
    resultArray.push(obj);
  }
  return [...resultArray];
}

export async function getValues(cb) {
  try {
    let result = await Excel.run(async function (context) {
      let selectedRange = context.workbook.getSelectedRange();

      selectedRange.load(" addressLocal"); // Tải giá trị, số hàng, số cột và định dạng số của ô được chọn
      await context.sync();
      let addressLocal = selectedRange.addressLocal;
      const ranges = splitRange(addressLocal.substring(addressLocal.indexOf("!") + 1), 50000)
      let headers = null;
      let headersFormat = null;
      for (let i = 0; i < ranges.length; i++) {
        const data = await getValuesOfRange(ranges[i])
        const numberFormats = await getNumberFormatOfRange(ranges[i])
        if (i === 0) {
          headers = data[0]
          headersFormat = numberFormats[0]
        }
        const values = i === 0 ? data : [headers, ...data]
        const numFormat = i === 0 ? numberFormats : [headersFormat, ...numberFormats]
        const resultSplitArray = formatValues(values, numFormat)
        await cb(resultSplitArray)
      }
    });
    return result;
  } catch (error) {
    console.log("Lỗi: " + error);
    return [];
  }
}

const showTaskpane = (url) => (event) => {
  Office.addin.showAsTaskpane()
    .then(function () {
      window.location.href = url
      // Code that enables task pane UI elements for
      // working with the current quarter.
      event.completed()
    })

    .catch(function (e) {
      event.completed()
    });
}
const g = getGlobal();

// the add-in command functions need to be available in global scope
g.run = run;
g.action = action;

g.login = showTaskpane('#/login');
